<template>
    <v-layout wrap>
        <v-flex class="mb-4 d-flex align-items-center">
            <div>
                <h1 class="d-inline-block vertical-align-middle">{{ $t('lookUp-details') }}</h1>
            </div>
        </v-flex>
        <!-- Add/Edit LookUp Form -->
        <v-form class="flex xs12 mb-3" @submit.prevent="saveLookUp">
            <v-card>
                <v-container grid-list-lg>
                    <v-layout wrap>
                        <v-flex md4 sm6 xs12>
                            <v-autocomplete :data-vv-as="$t('major')"
                                            :label="$t('major')"
                                            :items="lookUpList"
                                            v-model.number="lookUp.majorId"
                                            v-validate="'max:10|numeric'"
                                            :error-messages="errors.collect('majorId')"
                                            name="majorId"
                                            :item-text="getLabelByLang('enName', 'arName')"
                                            @change="getMaxCode"
                                            item-value="id"></v-autocomplete> <!-- -getMaxOrderIcons--->
                        </v-flex>
                        <v-flex md4 sm6 xs12>
                            <v-text-field :label="$t('code')"
                                          v-model.number="lookUp.code"
                                          v-validate="'required|max:50'"
                                          :data-vv-as="$t('code')"
                                          :error-messages="errors.collect('code')"
                                          name="code"></v-text-field>
                        </v-flex>
                        <v-flex md6 sm6 xs12>
                            <v-text-field :label="$t('arabic-name')"
                                          v-model="lookUp.arName"
                                          v-validate="'required|max:500'"
                                          :data-vv-as="$t('arabic-name')"
                                          :error-messages="errors.collect('arName')"
                                          name="arName"></v-text-field>
                        </v-flex>
                        <v-flex md6 sm6 xs12>
                            <v-text-field :label="$t('english-name')"
                                          v-model="lookUp.enName"
                                          v-validate="'max:500'"
                                          :data-vv-as="$t('english-name')"
                                          :error-messages="errors.collect('enName')"
                                          name="enName"></v-text-field>
                        </v-flex>
                        <v-flex md4 sm6 xs12>
                            <v-autocomplete :data-vv-as="$t('parent')"
                                            :label="$t('parent')"
                                            :items="lookUpList"
                                            v-model.number="lookUp.parentId"
                                            v-validate="'max:10|numeric'"
                                            :error-messages="errors.collect('parentId')"
                                            name="parentId"
                                            :item-text="getLabelByLang('enName', 'arName')"
                                            item-value="id"></v-autocomplete>
                        </v-flex>

                        <v-flex md4 sm6 xs12>
                            <v-text-field :label="$t('order-Icons')"
                                          v-model.number="lookUp.orderIcons"
                                          v-validate="'numeric|min_value:0|max_value:254'"
                                          :data-vv-as="$t('order-Icons')"
                                          :error-messages="errors.collect('orderIcons')"
                                          name="orderIcons"></v-text-field>
                        </v-flex>

                        <v-flex md4 sm6 xs12>
                            <v-switch v-model="lookUp.isMainLookUp" :label="$t('is-main-Lookup')"></v-switch>
                        </v-flex>
                        <v-flex xs12>
                            <v-btn color="primary" type="submit">{{ $t('save') }}</v-btn>
                            <v-btn color="primary" @click="lookupClose()">{{ $t('cancel') }}</v-btn>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-card>
        </v-form>
    </v-layout>
</template>

<script>
    import LookUpService from '@/services/LookUpService';
    const CREATE = 0;

    export default {
        name: 'lookUp-details',
        data() {
            return {
                selected: [],
                lookUp: {
                    code: 0,
                    arName: null,
                    enName: null,
                    majorId: null,
                    parentId: null,
                    orderIcons: 0,
                    isMainLookUp: false
                },

                datepicker: false,
                mode: CREATE,
                lookUpList: []
            };
        },
        props: {
            isDialog: { type: Boolean }
        },
        async created() {
            const lookUpId = this.$route.params.id;
            /* to call the  Entities (drop down lists)  which are used in this Entity */
            this.getMainLookups();
            if (lookUpId) {
                /* add loading in edit mode */
                this.$store.dispatch('showLoading');
                const lookUp = (await LookUpService.getLookUp(lookUpId)).data;
                this.$store.dispatch('hideLoading');
                if (!lookUp) this.$router.push({ name: 'lookUp-list' });
                this.lookUp = { ...this.lookUp, ...lookUp };
            }
        },
        methods: {
            /* save Operation */
            async saveLookUp() {
                const isValid = await this.$validator.validateAll();
                if (isValid) {
                    /* add loading on save */
                    this.$store.dispatch('showLoading');
                    const result = await LookUpService.saveLookUp(this.lookUp);
                    if (result.data.statusCode === 200) {
                        this.$store.dispatch('showMessage', { text: result.data.message });
                        if (!this.isDialog) this.$router.push({ name: 'lookup' });
                        else {
                            this.lookUp.id = parseInt(result.data.id, 10);
                            this.$emit('lookupEmitter', this.lookUp);
                        }
                    } else {
                        this.$store.dispatch('showMessage', {
                            text: result.data.message,
                            color: 'error'
                        });
                        this.$router.push({ name: 'lookup', color: 'error' });
                    }
                    this.$store.dispatch('hideLoading');
                }
            },
            lookupClose() {
                if (this.isDialog) this.$emit('lookupCloseEmitter');
                else this.$router.push({ name: 'lookup' });
            },
            /* Get Operations */
            async getMainLookups() {
                this.lookUpList = (await LookUpService.getMainLookups()).data;
            },
            saveDate(date) {
                this.$refs.menu.save(date);
            },
            async getMaxCode() { /* Get MaxCode by majorId */
                const result = await LookUpService.getMaxCodeLookup(this.lookUp.majorId);
                if (result.data) this.lookUp.code = result.data;
                this.getMaxOrderIcons();
            },
            async getMaxOrderIcons() { /* Get MaxOrderIcons by majorId  */
                const result = await LookUpService.getMaxOrderIconsLookup(this.lookUp.majorId);
                if (result.data) this.lookUp.orderIcons = result.data;
            }
        },
        watch: {
            datepicker(val) {
                val && this.$nextTick(() => (this.$refs.picker.activePicker = 'YEAR'));
            }
        }
    };
</script>